import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useLayoutStore = create(
  persist(
    (set) => ({
      railExpanded: false,
      panelWidth: 260,
      activeCategory: '',
      setRailExpanded: (v) => set({ railExpanded: v }),
      toggleRail: () => set((s) => ({ railExpanded: !s.railExpanded })),
      setPanelWidth: (v) => set({ panelWidth: v }),
      setActiveCategory: (c) => set({ activeCategory: c }),
      toggleCategory: (c) =>
        set((s) => ({ activeCategory: s.activeCategory === c ? '' : c })),
    }),
    {
      name: 'plattform-layout',
      partialize: (s) => ({ railExpanded: s.railExpanded, panelWidth: s.panelWidth }),
    }
  )
);

export default useLayoutStore;
